/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { OrganizationListRequest } from '../types/OrganizationList';
import type { OrganizationListResponse } from '../types/OrganizationList';

export type OrganizationsCreateRequest = OrganizationListRequest;
export type OrganizationsCreateResponse = OrganizationListResponse;

export type OrganizationsCreateQuery = {};

/**
 * POST /dmx-server/organizations/
 *
 * ```yaml
 * operationId: organizations_create
 * tags:
 *   - organizations
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/OrganizationList'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/OrganizationList'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/OrganizationList'
 *   required: true
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '201':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/OrganizationList'
 *     description: ''
 * ```
 */
export const organizationsCreateOperation = (rest?: OrganizationsCreateQuery | null) =>
  ({
    method: 'POST',
    path: `/dmx-server/organizations/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'POST';
    path: string & { _templateUrl: '/dmx-server/organizations/' };
  };

/**
 * POST /dmx-server/organizations/
 *
 * ```yaml
 * operationId: organizations_create
 * tags:
 *   - organizations
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/OrganizationList'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/OrganizationList'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/OrganizationList'
 *   required: true
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '201':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/OrganizationList'
 *     description: ''
 * ```
 */
export const organizationsCreate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query?: OrganizationsCreateQuery;
  request: OrganizationListRequest;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<OrganizationListResponse>> => {
  const operation = organizationsCreateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'POST',
    request,
    onUploadProgress,
    cancelToken,
  );
};
